export default __webpack_public_path__ + "static/media/site_edenimmo.b1e00dc5.webp";